import { inject, Injectable } from '@angular/core';
import { UserService } from '../../../../../core/services/user/user.service';
import { AlertService } from '../../../../../core/services/alert/alert.service';
import { Observable, tap } from 'rxjs';
import { UserEmailVerificationConstants } from './constants/user-email-verification-constants';
import { EmailVerificationStatus } from '../../../../../core/services/user/models/email-verification-status';

@Injectable({
    providedIn: 'root',
})
export class UserEmailVerificationService {
    private readonly alertService = inject(AlertService);
    private readonly userService = inject(UserService);

    getEmailVerificationStatus(
        userId: number,
    ): Observable<EmailVerificationStatus> {
        return this.userService.getEmailVerificationStatus(userId);
    }

    sendVerificationEmail(userId: number): void {
        this.userService
            .sendEmailVerificationEmail(userId)
            .pipe(
                tap(() => {
                    this.alertService.displaySuccessAlert(
                        UserEmailVerificationConstants.SUCCESSFUL_RESEND_MESSAGE,
                    );
                }),
            )
            .subscribe();
    }
}
